export const DraftStatus = {
  CREATED: 0,
  SUBMITTED: 1,
  APPROVED: 2,
  REJECTED: 3,
};

export const parseDraftStatus = status =>
  Number.parseInt(status, 10) || DraftStatus.CREATED;
